"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadManualStaticSubappAndSpa = exports.DynamicLoadManualStaticRoute = exports.DynamicLoadManualStatic = void 0;
const core_1 = require("../../../core");
const genericManual_1 = require("../genericManual");
const utils_1 = require("../utils");
class DynamicLoadManualStatic extends genericManual_1.GenericLoadManualStatic {
    constructor() {
        super(...arguments);
        this.initialize = (initializers, verticalConfig) => __awaiter(this, void 0, void 0, function* () {
            return verticalConfig.entrypoint(document.getElementById('microfrontend'), initializers.store, initializers.history, initializers.initializedFeatures, initializers.externalComponents, initializers.data);
        });
    }
}
exports.DynamicLoadManualStatic = DynamicLoadManualStatic;
DynamicLoadManualStatic.leaveVerticalConfigAvailable = (verticalId, verticalConfig) => {
    var _a, _b;
    window.globals = window.globals || {};
    window.globals[verticalId] = verticalConfig;
    (_b = (_a = window.globalPromises) === null || _a === void 0 ? void 0 : _a[verticalId]) === null || _b === void 0 ? void 0 : _b.call(_a);
    return window.globals[verticalId];
};
class DynamicLoadManualStaticRoute extends genericManual_1.GenericLoadManualStatic {
    constructor() {
        super(...arguments);
        this.initialize = (initializers, verticalConfig) => __awaiter(this, void 0, void 0, function* () {
            return verticalConfig.entrypoint(document.getElementById('staticMicrofrontendRoute'), initializers.store, initializers.initializedFeatures, initializers.externalComponents, initializers.data);
        });
    }
}
exports.DynamicLoadManualStaticRoute = DynamicLoadManualStaticRoute;
DynamicLoadManualStaticRoute.leaveVerticalConfigAvailable = (verticalId, verticalConfig) => {
    var _a, _b;
    window.globals = window.globals || {};
    window.globals[verticalId] = verticalConfig;
    (_b = (_a = window.globalPromises) === null || _a === void 0 ? void 0 : _a[verticalId]) === null || _b === void 0 ? void 0 : _b.call(_a);
    return window.globals[verticalId];
};
class DynamicLoadManualStaticSubappAndSpa extends DynamicLoadManualStatic {
    constructor() {
        super(...arguments);
        this.getUrl = (verticalId) => {
            return `/${this.projectId}-${verticalId}-${this.variant}/subapp.html`;
        };
        this.getBackupUrl = (verticalId) => {
            return `/${this.projectId}-${verticalId}-${this.variant}/index.html`;
        };
        this.getVerticalScripts = (verticalId) => __awaiter(this, void 0, void 0, function* () {
            try {
                const scriptText = yield (0, utils_1.getVerticalRequest)(this.getUrl(verticalId));
                return (0, utils_1.getVerticalSrc)(scriptText);
            }
            catch (_a) {
                try {
                    const scriptText = yield (0, utils_1.getVerticalRequest)(this.getBackupUrl(verticalId));
                    return (0, utils_1.getVerticalSrc)(scriptText);
                }
                catch (e) {
                    core_1.Log.warn(e.message);
                    return [];
                }
            }
        });
    }
}
exports.DynamicLoadManualStaticSubappAndSpa = DynamicLoadManualStaticSubappAndSpa;
//# sourceMappingURL=dynamicLoad.js.map